import { render, staticRenderFns } from "./ListTokenPricedView.vue?vue&type=template&id=13b10f3a"
import script from "./ListTokenPricedView.vue?vue&type=script&lang=ts"
export * from "./ListTokenPricedView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports